/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ReturnParcelsStatus {
  ALL = "all",
  CREATED = "created",
  FAILED = "failed",
}
